import axios from 'axios'
import axiosInstance from './service'

// File Storage API (server/server/files). Note the shared axios instance's
// response interceptor resolves with the error response instead of throwing,
// so callers check `res.status` / `res.data.error`.

export const getStorageMe = () => axiosInstance.get('/files/me')
export const getStorageUsage = () => axiosInstance.get('/files/usage')
export const browseStorage = (folderId) => axiosInstance.get('/files/browse', { params: { folder: folderId || '' } })
export const searchStorage = (q) => axiosInstance.get('/files/search', { params: { q } })
export const getStorageTree = () => axiosInstance.get('/files/tree')

export const createStorageFolder = (name, parent) => axiosInstance.post('/files/folders', { name, parent: parent || null })
export const renameStorageFolder = (id, name) => axiosInstance.put(`/files/folders/${id}`, { name })
export const moveStorageFolder = (id, parent) => axiosInstance.put(`/files/folders/${id}/move`, { parent: parent || null })
export const deleteStorageFolder = (id) => axiosInstance.delete(`/files/folders/${id}`)

export const initStorageUpload = (file, folder) => axiosInstance.post('/files/uploads', {
  name: file.name, size: file.size, type: file.type, folder: folder || null
})
export const completeStorageUpload = (id) => axiosInstance.post(`/files/uploads/${id}/complete`)
export const abortStorageUpload = (id) => axiosInstance.delete(`/files/uploads/${id}`)

export const getStorageDownloadUrl = (id, disposition = 'attachment') =>
  axiosInstance.get(`/files/files/${id}/download-url`, { params: { disposition } })
export const renameStorageFile = (id, name) => axiosInstance.put(`/files/files/${id}`, { name })
export const moveStorageFile = (id, folder) => axiosInstance.put(`/files/files/${id}/move`, { folder: folder || null })
export const deleteStorageFile = (id) => axiosInstance.delete(`/files/files/${id}`)

export const listStorageAccess = (folderId) => axiosInstance.get(`/files/folders/${folderId}/access`)
export const grantStorageAccess = (folderId, user, role) => axiosInstance.put(`/files/folders/${folderId}/access`, { user, role })
export const revokeStorageAccess = (folderId, userId) => axiosInstance.delete(`/files/folders/${folderId}/access/${userId}`)
export const searchStorageUsers = (q) => axiosInstance.get('/files/users', { params: { q } })

// The browser PUTs the bytes straight to S3. Plain axios on purpose: the
// shared instance would add the app's Authorization header, which S3 rejects
// because it is not part of the presigned signature. Content-Type must match
// what the server signed.
export const uploadToS3 = (url, file, contentType, { onProgress, signal } = {}) =>
  axios.put(url, file, {
    headers: { 'Content-Type': contentType },
    signal,
    onUploadProgress: (ev) => onProgress && onProgress(ev.loaded, ev.total || file.size)
  })
